export default "__VITE_ASSET__c0267a2d__"